<h1 mat-dialog-title>{{ "DIALOG.TITLE" | translate }}</h1>
<div mat-dialog-content>
    <div class="content-card" style="position: relative">
        <!-- <ngx-spinner name="billTable" type="ball-clip-rotate-multiple" [fullScreen]="false"> </ngx-spinner> -->
        <mat-table
            class="table"
            #table
            [dataSource]="skipTakeValidations()"
            matSort
            [@animateStagger]="{ value: '50' }"
            fusePerfectScrollbar
        >
            <ng-container matColumnDef="line">
                <mat-header-cell *matHeaderCellDef> {{ "DIALOG.GRID.LINE" | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let bill">
                    <p>
                        {{ bill.line }}
                    </p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef> {{ "DIALOG.GRID.EMAIL" | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let bill" [matTooltip]="bill.email">
                    <p>
                        {{ bill.email }}
                    </p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="errors">
                <mat-header-cell *matHeaderCellDef> {{ "DIALOG.GRID.ERRORS" | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let bill">
                    <p [matTooltip]="bill.errors">
                        {{ bill.errors }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="copy">
                <mat-header-cell *matHeaderCellDef>
                    <button
                        [cdkCopyToClipboard]="getTsvFromValidations()"
                        (click)="msgCopy()"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="'DIALOG.COPY_ALL' | translate"
                    >
                        <mat-icon>file_copy</mat-icon>
                    </button>
                </mat-header-cell>
                <mat-cell *matCellDef="let bill">
                    <button
                        [cdkCopyToClipboard]="bill.errors"
                        (click)="msgCopy()"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="'DIALOG.COPY' | translate"
                    >
                        <mat-icon>file_copy</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

            <mat-row *matRowDef="let bill; columns: displayedColumns" class="rows" matRipple> </mat-row>
        </mat-table>

        <mat-paginator
            #paginator
            [length]="data.validations?.length"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="load($event)"
        >
        </mat-paginator>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button
        [id]="'button_invite-list-dialog_Yes'"
        mat-button
        mat-raised-button
        [mat-dialog-close]="true"
        cdkFocusInitial
    >
        Ok
    </button>
</div>
